// import React, { useState, useEffect } from "react";
// import { Modal, Button, Table, Input, Select, Tabs, Form, Space, message, notification, Tag, Checkbox } from "antd";
// import { FaPlus, FaEdit, FaTrash, FaSearch } from "react-icons/fa";
// import { apiHandle } from "../../config/apiHandle";

// const { TabPane } = Tabs;
// const { Option } = Select;

// const PermissionSection = ({ module, form }) => {
//   const readPath = ['permissions', module, 'read'];

//   return (
//     <div style={{ marginBottom: 16 }}>
//       <h4 style={{ marginBottom: 8 }}>{module.charAt(0).toUpperCase() + module.slice(1)}</h4>
//       <Space>
//         {/* Read Permission - Always visible */}
//         <Form.Item
//           name={readPath}
//           valuePropName="checked"
//           noStyle
//           rules={[
//             ({ getFieldValue }) => ({
//               validator(_, value) {
//                 if (getFieldValue(['permissions', module, 'create']) && !value) {
//                   return Promise.reject(new Error('Read permission is required for other permissions'));
//                 }
//                 return Promise.resolve();
//               },
//             }),
//           ]}
//         >
//           <Checkbox
//             onChange={(e) => {
//               if (!e.target.checked) {
//                 // Reset other permissions when Read is unchecked
//                 form.setFieldsValue({
//                   [['permissions', module, 'create'].join('.')]: false,
//                   [['permissions', module, 'update'].join('.')]: false,
//                   [['permissions', module, 'delete'].join('.')]: false,
//                 });
//               }
//             }}
//           >
//             Read
//           </Checkbox>
//         </Form.Item>

//         {/* Conditional permissions */}
//         <Form.Item noStyle shouldUpdate>
//           {({ getFieldValue }) =>
//             getFieldValue(readPath) && (
//               <>
//                 <Form.Item name={['permissions', module, 'create']} valuePropName="checked" noStyle>
//                   <Checkbox>Create</Checkbox>
//                 </Form.Item>
//                 <Form.Item name={['permissions', module, 'update']} valuePropName="checked" noStyle>
//                   <Checkbox>Update</Checkbox>
//                 </Form.Item>
//                 <Form.Item name={['permissions', module, 'delete']} valuePropName="checked" noStyle>
//                   <Checkbox>Delete</Checkbox>
//                 </Form.Item>
//               </>
//             )
//           }
//         </Form.Item>
//       </Space>
//     </div>
//   );
// };

// const Users = () => {
//   const [users, setUsers] = useState([]);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [editingUser, setEditingUser] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [form] = Form.useForm();
//   const [search, setSearch] = useState("");
//   const [currentRole, setCurrentRole] = useState("subAdmin");
//   const roleValue = Form.useWatch('role', form);

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   const fetchUsers = async () => {
//     setLoading(true);
//     try {
//       const response = await apiHandle.get("admin/get-users");
//       setUsers(response.data.data);
//     } catch (error) {
//       message.error("Failed to fetch users.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // const handleAddOrUpdateUser = async () => {
//   //   try {
//   //     const values = await form.validateFields();
//   //     setLoading(true);

//   //     if (editingUser) {
//   //       // Handle update with permissions
//   //       const userPayload = {
//   //         email: values.email,
//   //         role: currentRole,
//   //         ...(currentRole === "Vendor" && {
//   //           first_name: values.first_name,
//   //           last_name: values.last_name,
//   //           phonenumber: values.phonenumber
//   //         }),
//   //         status: values.status
//   //       };

//   //       // Update user details
//   //       await apiHandle.post(`admin/edit-user/${editingUser._id}`, userPayload);

//   //       // Update permissions if subAdmin or Vendor
//   //       if (currentRole === "subAdmin" || currentRole === "Vendor") {
//   //         await apiHandle.put(`admin/permission-update/${editingUser._id}`, values.permissions);
//   //       }

//   //       notification.success({ message: "User updated successfully" });
//   //     } else {
//   //       // Handle create without permissions
//   //       const userPayload = {
//   //         email: values.email,
//   //         password: values.password,
//   //         role: currentRole,
//   //         ...(currentRole === "Vendor" && {
//   //           first_name: values.first_name,
//   //           last_name: values.last_name,
//   //           phonenumber: values.phonenumber
//   //         })
//   //       };

//   //       await apiHandle.post("admin/add-user", userPayload);
//   //       notification.success({ message: "User added successfully" });
//   //     }

//   //     fetchUsers();
//   //     form.resetFields();
//   //     setIsModalVisible(false);
//   //     setEditingUser(null);
//   //   } catch (error) {
//   //     notification.error({
//   //       message: error.response?.data?.message || "An error occurred. Please try again."
//   //     });
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const handleAddOrUpdateUser = async () => {
//     try {
//       const values = await form.validateFields();
//       setLoading(true);


//       const selectedRole = values.role;

//       if (editingUser) {
//         const userPayload = {
//           email: values.email,
//           role: selectedRole,
//           ...(selectedRole === "Vendor" && {
//             first_name: values.first_name,
//             last_name: values.last_name,
//             phonenumber: values.phonenumber
//           }),
//           status: values.status
//         };

//         await apiHandle.post(`admin/edit-user/${editingUser._id}`, userPayload);

//         if (selectedRole === "subAdmin" || selectedRole === "Vendor") {
//           await apiHandle.put(`admin/permission-update/${editingUser._id}`, values.permissions);
//         }

//         notification.success({ message: "User updated successfully" });
//       } else {
//         const userPayload = {
//           email: values.email,
//           password: values.password,
//           role: selectedRole,
//           ...(selectedRole === "Vendor" && {
//             first_name: values.first_name,
//             last_name: values.last_name,
//             phonenumber: values.phonenumber
//           })
//         };

//         await apiHandle.post("admin/add-user", userPayload);
//         notification.success({ message: "User added successfully" });
//       }

//       fetchUsers();
//       form.resetFields();
//       setIsModalVisible(false);
//       setEditingUser(null);
//     } catch (error) {
//       notification.error({
//         message: error.response?.data?.message || "An error occurred. Please try again."
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleEdit = (record) => {
//     setEditingUser(record);
//     form.setFieldsValue({
//       ...record,
//       role: record.role,
//       phonenumber: record.phonenumber || "",
//       status: record.status,
//       permissions: record.permissions || {
//         stores: { create: false, read: false, update: false, delete: false },
//         orders: { create: false, read: false, update: false, delete: false },
//         products: { create: false, read: false, update: false, delete: false },
//         ...(record.role === "subAdmin" && {
//           variant: { create: false, read: false, update: false, delete: false }
//         })
//       }
//     });
//     setIsModalVisible(true);
//   };

//   const filteredUsers = users.filter(
//     (user) => user.role === currentRole && user.email.toLowerCase().includes(search.toLowerCase())
//   );

//   const columns = [
//     { title: "Email", dataIndex: "email", key: "email" },
//     ...(currentRole === "Vendor"
//       ? [
//         { title: "First Name", dataIndex: "first_name", key: "first_name" },
//         { title: "Last Name", dataIndex: "last_name", key: "last_name" },
//         { title: "Phone Number", dataIndex: "phonenumber", key: "phonenumber" },
//       ]
//       : []),
//     { title: "Role", dataIndex: "role", key: "role" },
//     {
//       title: "Status",
//       dataIndex: "status",
//       key: "status",
//       render: (status) => (
//         <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
//       )
//     },
//     {
//       title: "Actions",
//       key: "actions",
//       render: (text, record) => (
//         <Space>
//           <Button icon={<FaEdit />} onClick={() => handleEdit(record)} />
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
//       <h1 className="text-3xl font-bold text-center mb-4">User Management</h1>
//       {/* <Tabs activeKey={currentRole} onChange={setCurrentRole}>
//         <TabPane tab="subAdmin" key="subAdmin" />
//         <TabPane tab="Vendor" key="Vendor" />
//       </Tabs> */}
//       <Tabs
//         activeKey={currentRole}
//         onChange={(key) => {
//           setCurrentRole(key);
//           form.resetFields();
//         }}
//       >
//         <TabPane tab="subAdmin" key="subAdmin" />
//         <TabPane tab="Vendor" key="Vendor" />
//       </Tabs>
//       <div className="flex justify-between my-4">
//         <Input
//           placeholder="Search by email"
//           prefix={<FaSearch />}
//           onChange={(e) => setSearch(e.target.value)}
//           style={{ width: 300 }}
//         />
//         <Button
//           type="primary"
//           icon={<FaPlus />}
//           onClick={() => {
//             form.resetFields();
//             form.setFieldsValue({
//               role: currentRole,
//               status: "Active"
//             });
//             setIsModalVisible(true);
//           }}
//         >
//           Add User
//         </Button>
//         {/* <Button
//           type="primary"
//           icon={<FaPlus />}
//           onClick={() => {
//             form.resetFields();
//             form.setFieldsValue({ role: currentRole });
//             setIsModalVisible(true);
//           }}
//         >
//           Add User
//         </Button> */}
//       </div>
//       <Table
//         columns={columns}
//         dataSource={filteredUsers}
//         pagination={{ pageSize: 15 }}
//         rowKey="_id"
//         loading={loading}
//       />
//       <Modal
//         title={editingUser ? "Edit User" : "Add User"}
//         visible={isModalVisible}
//         onCancel={() => {
//           setIsModalVisible(false);
//           setEditingUser(null);
//           form.resetFields();
//         }}
//         onOk={handleAddOrUpdateUser}
//         confirmLoading={loading}
//       >
//         <Form form={form} layout="vertical">
//           <Form.Item name="role" label="Role">
//             <Select>
//               <Option value="subAdmin">subAdmin</Option>
//               <Option value="Vendor">Vendor</Option>
//             </Select>
//           </Form.Item>

//           {currentRole === "Vendor" && (
//             <>
//               <Form.Item name="first_name" label="First Name">
//                 <Input />
//               </Form.Item>
//               <Form.Item name="last_name" label="Last Name">
//                 <Input />
//               </Form.Item>
//               <Form.Item name="phonenumber" label="Phone Number">
//                 <Input />
//               </Form.Item>
//             </>
//           )}

//           <Form.Item name="email" label="Email" rules={[{ required: true, type: "email" }]}>
//             <Input />
//           </Form.Item>

//           {!editingUser && (
//             <Form.Item name="password" label="Password" rules={[{ required: true }]}>
//               <Input.Password />
//             </Form.Item>
//           )}

//           {editingUser && (
//             <>
//               <Form.Item name="status" label="Status">
//                 <Select>
//                   <Option value="Active">Active</Option>
//                   <Option value="Inactive">Inactive</Option>
//                 </Select>
//               </Form.Item>
//               {/* // In your Users component render method: */}
//               {(currentRole === "subAdmin" || currentRole === "Vendor") && (
//                 <Form.Item label="Permissions">
//                   {currentRole === "subAdmin" && (
//                     <>
//                       <PermissionSection module="stores" form={form} />
//                       <PermissionSection module="orders" form={form} />
//                       <PermissionSection module="products" form={form} />
//                       <PermissionSection module="variant" form={form} />
//                     </>
//                   )}
//                   {currentRole === "Vendor" && (
//                     <>
//                       <PermissionSection module="stores" form={form} />
//                       <PermissionSection module="orders" form={form} />
//                       <PermissionSection module="products" form={form} />
//                     </>
//                   )}
//                 </Form.Item>
//               )}
//             </>
//           )}
//         </Form>
//       </Modal>
//     </div>
//   );
// };

// export default Users;



import React, { useState, useEffect } from "react";
import { Modal, Button, Table, Input, Select, Tabs, Form, Space, message, notification, Tag, Checkbox } from "antd";
import { FaPlus, FaEdit, FaTrash, FaSearch } from "react-icons/fa";
import { apiHandle } from "../../config/apiHandle";

const { TabPane } = Tabs;
const { Option } = Select;

const PermissionSection = ({ module, form }) => {
  const readPath = ['permissions', module, 'read'];

  return (
    <div style={{ marginBottom: 16 }}>
      <h4 style={{ marginBottom: 8 }}>{module.charAt(0).toUpperCase() + module.slice(1)}</h4>
      <Space>
        {/* Read Permission - Always visible */}
        <Form.Item
          name={readPath}
          valuePropName="checked"
          noStyle
          rules={[
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (getFieldValue(['permissions', module, 'create']) && !value) {
                  return Promise.reject(new Error('Read permission is required for other permissions'));
                }
                return Promise.resolve();
              },
            }),
          ]}
        >
          <Checkbox
            onChange={(e) => {
              if (!e.target.checked) {
                // Reset other permissions when Read is unchecked
                form.setFieldsValue({
                  [['permissions', module, 'create'].join('.')]: false,
                  [['permissions', module, 'update'].join('.')]: false,
                  [['permissions', module, 'delete'].join('.')]: false,
                });
              }
            }}
          >
            Read
          </Checkbox>
        </Form.Item>

        {/* Conditional permissions */}
        <Form.Item noStyle shouldUpdate>
          {({ getFieldValue }) =>
            getFieldValue(readPath) && (
              <>
                <Form.Item name={['permissions', module, 'create']} valuePropName="checked" noStyle>
                  <Checkbox>Create</Checkbox>
                </Form.Item>
                <Form.Item name={['permissions', module, 'update']} valuePropName="checked" noStyle>
                  <Checkbox>Update</Checkbox>
                </Form.Item>
                <Form.Item name={['permissions', module, 'delete']} valuePropName="checked" noStyle>
                  <Checkbox>Delete</Checkbox>
                </Form.Item>
              </>
            )
          }
        </Form.Item>
      </Space>
    </div>
  );
};

const Users = () => {
  const [users, setUsers] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingUser, setEditingUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [search, setSearch] = useState("");
  const [currentRole, setCurrentRole] = useState("subAdmin");
  const roleValue = Form.useWatch('role', form);

  useEffect(() => {
    fetchUsers();
  }, []);

  // Initialize default permissions based on selected role
  useEffect(() => {
    if (roleValue && !editingUser) {
      const defaultPermissions = {
        stores: { create: false, read: false, update: false, delete: false },
        orders: { create: false, read: false, update: false, delete: false },
        products: { create: false, read: false, update: false, delete: false }
      };
      
      // Add variant permission only for subAdmin
      if (roleValue === "subAdmin") {
        defaultPermissions.variant = { create: false, read: false, update: false, delete: false };
      }
      
      form.setFieldsValue({ permissions: defaultPermissions });
    }
  }, [roleValue, form, editingUser]);

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await apiHandle.get("admin/get-users");
      setUsers(response.data.data);
    } catch (error) {
      message.error("Failed to fetch users.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddOrUpdateUser = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);

      const selectedRole = values.role;

      if (editingUser) {
        const userPayload = {
          email: values.email,
          role: selectedRole,
          ...(selectedRole === "Vendor" && {
            first_name: values.first_name,
            last_name: values.last_name,
            phonenumber: values.phonenumber
          }),
          status: values.status
        };

        await apiHandle.post(`admin/edit-user/${editingUser._id}`, userPayload);

        if (selectedRole === "subAdmin" || selectedRole === "Vendor") {
          await apiHandle.put(`admin/permission-update/${editingUser._id}`, values.permissions);
        }

        notification.success({ message: "User updated successfully" });
      } else {
        const userPayload = {
          email: values.email,
          password: values.password,
          role: selectedRole,
          ...(selectedRole === "Vendor" && {
            first_name: values.first_name,
            last_name: values.last_name,
            phonenumber: values.phonenumber
          })
        };

        // First create the user
        const response = await apiHandle.post("admin/add-user", userPayload);
        
        // If user creation was successful and has permissions, update them
        if (response.data && response.data.data && response.data.data._id) {
          const userId = response.data.data._id;
          
          if ((selectedRole === "subAdmin" || selectedRole === "Vendor") && values.permissions) {
            await apiHandle.put(`admin/permission-update/${userId}`, values.permissions);
          }
        }

        notification.success({ message: "User added successfully" });
      }

      fetchUsers();
      form.resetFields();
      setIsModalVisible(false);
      setEditingUser(null);
    } catch (error) {
      notification.error({
        message: error.response?.data?.message || "An error occurred. Please try again."
      });
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record) => {
    setEditingUser(record);
    form.setFieldsValue({
      ...record,
      role: record.role,
      phonenumber: record.phonenumber || "",
      status: record.status,
      permissions: record.permissions || {
        stores: { create: false, read: false, update: false, delete: false },
        orders: { create: false, read: false, update: false, delete: false },
        products: { create: false, read: false, update: false, delete: false },
        ...(record.role === "subAdmin" && {
          variant: { create: false, read: false, update: false, delete: false }
        })
      }
    });
    setIsModalVisible(true);
  };

  const filteredUsers = users.filter(
    (user) => user.role === currentRole && user.email.toLowerCase().includes(search.toLowerCase())
  );

  const columns = [
    { title: "Email", dataIndex: "email", key: "email" },
    ...(currentRole === "Vendor"
      ? [
        { title: "First Name", dataIndex: "first_name", key: "first_name" },
        { title: "Last Name", dataIndex: "last_name", key: "last_name" },
        { title: "Phone Number", dataIndex: "phonenumber", key: "phonenumber" },
      ]
      : []),
    { title: "Role", dataIndex: "role", key: "role" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status === "Active" ? "green" : "red"}>{status}</Tag>
      )
    },
    {
      title: "Actions",
      key: "actions",
      render: (text, record) => (
        <Space>
          <Button icon={<FaEdit />} onClick={() => handleEdit(record)} />
        </Space>
      ),
    },
  ];

  // Show vendor-specific fields based on the selected role
  const showVendorFields = roleValue === "Vendor";

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-center mb-4">User Management</h1>
      <Tabs
        activeKey={currentRole}
        onChange={(key) => {
          setCurrentRole(key);
          form.resetFields();
        }}
      >
        <TabPane tab="subAdmin" key="subAdmin" />
        <TabPane tab="Vendor" key="Vendor" />
      </Tabs>
      <div className="flex justify-between my-4">
        <Input
          placeholder="Search by email"
          prefix={<FaSearch />}
          onChange={(e) => setSearch(e.target.value)}
          style={{ width: 300 }}
        />
        <Button
          type="primary"
          icon={<FaPlus />}
          onClick={() => {
            form.resetFields();
            form.setFieldsValue({
              role: currentRole,
              status: "Active"
            });
            setIsModalVisible(true);
          }}
        >
          Add User
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={filteredUsers}
        pagination={{ pageSize: 15 }}
        rowKey="_id"
        loading={loading}
      />
      <Modal
        title={editingUser ? "Edit User" : "Add User"}
        visible={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setEditingUser(null);
          form.resetFields();
        }}
        onOk={handleAddOrUpdateUser}
        confirmLoading={loading}
        width={600}
      >
        <Form form={form} layout="vertical">
          <Form.Item name="role" label="Role" initialValue={currentRole}>
            <Select>
              <Option value="subAdmin">subAdmin</Option>
              <Option value="Vendor">Vendor</Option>
            </Select>
          </Form.Item>

          {/* Show Vendor fields based on the selected role */}
          {showVendorFields && (
            <>
              <Form.Item name="first_name" label="First Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="last_name" label="Last Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
              <Form.Item name="phonenumber" label="Phone Number" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </>
          )}

          <Form.Item name="email" label="Email" rules={[{ required: true, type: "email" }]}>
            <Input />
          </Form.Item>

          {!editingUser && (
            <Form.Item name="password" label="Password" rules={[{ required: true }]}>
              <Input.Password />
            </Form.Item>
          )}

          {/* Show status field only when editing */}
          {editingUser && (
            <Form.Item name="status" label="Status">
              <Select>
                <Option value="Active">Active</Option>
                <Option value="Inactive">Inactive</Option>
              </Select>
            </Form.Item>
          )}

          {/* Always show permissions section based on selected role */}
          <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => 
            prevValues.role !== currentValues.role
          }>
            {({ getFieldValue }) => {
              const role = getFieldValue('role');
              return (
                role && (
                  <Form.Item label="Permissions">
                    {role === "subAdmin" && (
                      <>
                        <PermissionSection module="stores" form={form} />
                        <PermissionSection module="orders" form={form} />
                        <PermissionSection module="products" form={form} />
                        <PermissionSection module="variant" form={form} />
                      </>
                    )}
                    {role === "Vendor" && (
                      <>
                        <PermissionSection module="stores" form={form} />
                        <PermissionSection module="orders" form={form} />
                        <PermissionSection module="products" form={form} />
                      </>
                    )}
                  </Form.Item>
                )
              );
            }}
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Users;